// src/constants/potColours.ts
// Consistent colours for wealth pot categories — used across all screens

export const POT_COLOURS = {
  cash:         '#93C5FD',   // light blue  — cash savings and EF
  investments:  '#6EE7B7',   // green       — ISA and investments
  pension:      '#1E3A5F',   // dark navy   — all pension pots
  property:     '#C9A84C',   // gold        — property equity
  mortgage:     '#EF4444',   // red         — mortgage balance (liability)
  debt:         '#F97316',   // orange      — other debt / interest cost
} as const

export type PotColour = keyof typeof POT_COLOURS
